const textContentReplace = (inputString?: string) => {
    if (!inputString) return '';
    const regex = /<[^>]*>/g;
    // 使用正则表达式替换所有 HTML 标签为空字符串
    const result = inputString.replace(regex, '');
    return result;
};
export const getContentInnerText = (input?: string) => textContentReplace(input);
